module.exports = __webpack_public_path__ + "img/redo.caa87753.svg";